<template>
  <div class="flex flex-row justify-between">

    <div class="max-w-[139px]">
      <p v-if="product.classification !== 'transportation'" class="product-name">
        <a :href="`/products/${product.slug}`" class="hover:font-semibold transition-all">
          {{ product.name }}
        </a>
      </p>
      <p v-else class="product-name">
        {{ product.name }}
      </p>
    </div>

    <div class="flex items-center justify-center w-[134px]">
      <span v-if="product.classification !== 'transportation'">
        <quantity-control
          v-model="quantity"
          :minimum="0"
          :disabled="loading"
          class="is-small"
          @input="handleQuantityChange" 
        />
      </span>
      <div v-else class="order-item-quantity flex items-center justify-center">
        <p>{{ item.quantity }}</p>
      </div>
    </div>

    <div v-if="showPrice" class="flex items-center w-[79px]">
      <p class="price-txt">{{ dollars(item.priceCents) }}</p>
    </div>
  </div>
</template>

<script>
import { dollars } from 'shared/filters'
import QuantityControl from 'shared/components/quantity-control.vue'
export default {
  components: {
    QuantityControl
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    showPrice: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      quantity: this.item.quantity
    }
  },
  computed: {
    product () {
      return this.item.priceBookEntry.product
    }
  },
  methods: {
    dollars,
    // async remove () {
    //   await this.$store.dispatch('quote/quote.save', {
    //     eventName: 'item.delete',
    //     input: {
    //       item: {
    //         id: this.item.id
    //       }
    //     }
    //   })
    // },
    async handleQuantityChange () {
      this.loading = true
      await this.$store.dispatch('quote/quote.save', {
        eventName: 'item.update',
        input: {
          item: {
            id: this.item.id,
            quantity: this.quantity
          }
        }
      })
      this.loading = false
    }
  }
}
</script>

<style scoped>
.product-name {
  font-size: 12px;
  font-weight: 400;
  line-height: 16.8px;
  color: #334155;
}
.price-txt {
  font-size: 14px;
  font-weight: 700;
  line-height: 19.6px;
  letter-spacing: -0.02em;
  color: #334155;
}
.order-item-quantity {
  width: 44px;
  height: 44px;
  background-color: #FFF;
  border: 1px solid #EDE9E3;
}

.order-item-quantity p {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: -0.02em;
  color: #334155;
}
</style>
